import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { STATES_DATA } from 'src/assets/statesData';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-state-picker',
  templateUrl: './state-picker.component.html',
  styleUrls: ['./state-picker.component.scss'],
})
export class StatePickerComponent implements OnInit, OnDestroy {
  types = STATES_DATA
  destroyed$ = new Subject<boolean>();
  constructor(
    private modalCtrl: ModalController,
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  selectState(state){
    const stateSelected = state;
    this.modalCtrl.dismiss({data: stateSelected} );
  }

  async close() {
    this.modalCtrl.dismiss();
  }

}
